const ItemBlindTitle = (options, optionOrder) => {
  if (!options) return '';
  const optionItem = options[optionOrder];
  if (!optionItem) return '';
  const title = optionItem.value || optionItem.optionTitle.split('|').pop();
  return `<div class="h_optDetail"><h2>${title}</h2></div>`;
};

export default ItemBlindTitle;
